import NavItem from "./NavItem";

const NavItemsContainer = ({ list, setIsOpen, title, appOnly = false }) => {
  return (
    <div className={`dashboard-nav-items ${appOnly ? "is-app" : ""}`}>
      {title && <p>{title}</p>}
      <ul>
        {list?.map((item) => (
          <NavItem
            key={`${item.link}-${item.text}`}
            permission={item.permission || false}
            link={item.link}
            text={item.text}
            icon={item.icon}
            badge={item.badge}
            setIsOpen={setIsOpen}
          />
        ))}
      </ul>
    </div>
  );
};

export default NavItemsContainer;
